import axios from "../config/axios";
import axiosV2 from "../config/axios.v2";
import { CHANGE_PASSWORD_URL, FORGET_PASSWORD_URL, LOGIN_URL } from "./api.url.service";
import { useSnackbar } from "notistack";

const Users = {
  login: function (payload) {
    return axios
      .post(LOGIN_URL, payload)
      .then((resp) => {
        return resp.data;
      })
      .catch((err) => {
        console.log("err:::", err);
        const { enqueueSnackbar } = useSnackbar();
        enqueueSnackbar(err, { variant: "error" });
      });
  },
  // Authenticated change-password: verifies oldPassword, invalidates every other
  // session and returns a fresh token for this one.
  changePassword: function (payload) {
    return axiosV2.post(CHANGE_PASSWORD_URL, payload).then((resp) => resp.data);
  },
  forgetpassword: function (payload) {
    return axios.post(FORGET_PASSWORD_URL, payload).then((response) => {
      return response.data;
    })
      .catch((err) => {
        console.log("Err", err);
        return err;
      })
  }
};

export default Users;
